/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import { NavLink, useHistory, useParams } from "react-router-dom";
import { Button, Col, Row } from "antd";
import PageContainer from "../../components/PageContainer";
import withWikiWrapper from "./WikiWrapper";
import ContentSearch from "../blog/components/ContentSearch";
import CarouselSlide from "./CarouselSlide";
import LegalVocabulary from "./legalVocabulary/LegalVocabulary";
import { getCategoryService, getContentCategoryService } from "./wiki.api";
import Mask from "../../images/wiki/Mask Group 206.png";
import { Messages } from "../../components/Messages";
import { LeftOutlined, RollbackOutlined } from "@ant-design/icons";
import useLocalStorage from "../../hooks/useLocalStorage";

const Wiki = () => {
  const firstWikiItemRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [hasError, setHasError] = useState(false);
  const history = useHistory();
  // const [storedValue, setValue] = useLocalStorage("wiki", []);
  const [value, setValue] = useState([]);
  const params = useParams();

  useEffect(() => {
    if (params.parentId) {
      setValue((pre) => [
        ...pre,
        { id: params.parentId, title: params.parentId },
      ]);
    }
  }, [params]);

  const scroll = () => {
    if (firstWikiItemRef.current) {
      firstWikiItemRef.current.scrollIntoView({
        inline: "start",
        block: "nearest",
      });
    }
  };

  function fetchData() {
    setLoading(true);
    setHasError(false);
    getContentCategoryService()
      .then((res) => {
        if (res.data.hasOwnProperty("content")) {
          const result = res.data.content.filter(
            (cont) => !cont.parentId && cont
          );
          setCategories(result.reverse());
        } else {
          setCategories([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setHasError(true);
      })
      .finally(() => {
        setLoading(false);
        scroll();
      });
  }

  const getCategoryServiceHandler = () => {
    setLoading(true);
    setHasError(false);
    const theId = value.length > 0 ? value[value.length - 1].id : "";
    getCategoryService(theId)
      .then((res) => {
        setCategories(res.data.content.reverse());
      })
      .catch((err) => {
        console.error(err);
        setHasError(true);
      })
      .finally(() => {
        setLoading(false);
        scroll();
      });
  };

  useEffect(() => {
    if (value.length > 0) {
      getCategoryServiceHandler();
    } else {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const clickToRoute = (category) => {
    if (category?.isLeaf) {
      history.push(`/wiki/category/${category.id}`);
    } else {
      history.push(`/wiki/${category.id}`);
      const newStackValue = [
        ...value,
        { id: category.id, title: category.title },
      ];
      setValue(newStackValue);
    }
  };

  const onBack = () => {
    history.goBack();
  };

  return (
    <PageContainer
      classNames="wrap-wiki"
      sideBar
      headerProps={{
        left: params.parentId && (
          <Button onClick={onBack} type="text">
            <LeftOutlined className="back-icon" />
          </Button>
        ),
        tall: true,
        right: <Messages />,
        content: "سامانه جامع اطلاعات حقوقی",
        children: (
          <div style={{ marginTop: 43 }}>
            <ContentSearch
              showFilterForm={false}
              allowClear={true}
              inputName="keyword"
              contentType={"wiki"}
            />
          </div>
        ),
        className: "home-header-holder wrap-wiki-header",
      }}
      loading={loading}
    >

      {hasError && (
        <div className="error-box">
          <h4> خطا در دریافت اطلاعات </h4>
          <Button loading={loading} onClick={fetchData}>
            تلاش مجدد
          </Button>
        </div>
      )}
      <Row>
        <Col span={24}>
          <div className="legal-vocabulary-list">
            {categories &&
              categories.map((category) => (
                  <LegalVocabulary
                  key={category.id}
                    loading={loading}
                    category={category}
                    showDivider={true}
                    // allowRequest={category.hasOwnProperty("id")}
                    headerClick={() => {
                      clickToRoute(category);
                    }}
                  />
              ))}
          </div>
          {!value.length > 0 ? (
            <>
              <img
                src={Mask}
                alt="mask"
                style={{ margin: "0 auto", display: "block" }}
              />
              <div className="legal-calculator">
                <p className="title">محاسبه گر حقوقی</p>
                <p className="text">
                  با استفاده از محاسبه گر حقوقی، کاربر می تواند تمامی محاسبات
                  حقوقی مورد نیاز خود از جمله محاسبه خسارت تاخیر تادیه، هزینه
                  دادرسی، حق الوکاله وکیل، دیه و غیره را به راحتی انجام دهد.
                </p>
              </div>
              <NavLink to={`/wiki/calculator`} className="open-app">
                ورود به محاسبه گر حقوقی
              </NavLink>
            </>
          ) : (
            <div style={{ height: 130 }} />
          )}
        </Col>
      </Row>
    </PageContainer>
  );
};

export default withWikiWrapper(Wiki);
